"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndicatorValue = void 0;
var create_entity_1 = require("../../utils/create-entity");
exports.IndicatorValue = {
  name: 'IndicatorValue',
  type: 'standard',
  autoRoutes: ['create', 'update', 'list'],
  table: {
    fieldNames: ["indicator", "value", "date", "description"]
  },
  form: {
    modal: {
      fill: true
    },
    fieldSets: [{
      name: 'overview'
    }],
    fields: __assign(__assign({}, create_entity_1.entityCoreFormFields), {
      indicator: {
        type: 'linked',
        required: true,
        description: "Which {{INDICATOR}} does this {{INDICATOR_VALUE}} measure?",
        entityTypeName: 'Indicator'
      },
      date: {
        type: 'date',
        description: "Is there a date which applies to this {{INDICATOR_VALUE}}?"
      },
      value: {
        type: 'text',
        description: "What is the specific value, if applicable?"
      },
      description: {
        type: 'longText',
        description: "Is there a description associated with the value?"
      }
    })
  }
};